/* unplugin-vue-components disabled */import script from "./course-tutor-team.vue?vue&type=script&setup=true&lang=ts"
export * from "./course-tutor-team.vue?vue&type=script&setup=true&lang=ts"

import "./course-tutor-team.vue?vue&type=style&index=0&id=3d5dc27d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5dc27d"]])

export default __exports__